// types
import { IAppError, IErrorLogEntry } from './types';

// ==============================|| ERRORS - SESSION LOG (pure store logic) ||============================== //
// Log-ul de erori al sesiunii, cel mai nou primul (convenția listelor din aplicație).
// Erorile IDENTICE (aceeași sursă/categorie/status/cerere/mesaj) apărute într-un
// interval scurt se cumulează pe aceeași intrare (contor), ca un buton stricat apăsat
// de 5 ori să nu umple log-ul și ecranul de toast-uri. Log-ul e plafonat — cele mai
// vechi intrări se elimină (rămân doar în sesiunea curentă, nu se persistă nicăieri).

export const ERROR_DEDUP_WINDOW_MS = 30_000;
export const ERROR_LOG_CAP = 100;

const identityOf = (e: IAppError): string =>
	[e.source, e.category, e.status ?? '', e.method ?? '', e.url ?? '', e.message].join(
		'|'
	);

let sequence = 0;

export interface IUpsertResult {
	log: IErrorLogEntry[];
	entry: IErrorLogEntry;
	isNew: boolean;
}

export function upsertError(
	log: IErrorLogEntry[],
	error: IAppError,
	nowMs: number
): IUpsertResult {
	const identity = identityOf(error);
	const existing = log.find(
		(candidate) =>
			identityOf(candidate.error) === identity &&
			nowMs - Date.parse(candidate.lastAt) <= ERROR_DEDUP_WINDOW_MS
	);

	if (existing) {
		// păstrăm eroarea cea mai RECENTĂ pe intrare (requestId/timestamp proaspete
		// pentru copiere/raportare), dar identitatea și prima apariție rămân
		const entry: IErrorLogEntry = {
			...existing,
			error,
			count: existing.count + 1,
			lastAt: error.timestamp
		};
		return {
			log: log.map((candidate) => (candidate.id === existing.id ? entry : candidate)),
			entry,
			isNew: false
		};
	}

	sequence += 1;
	const entry: IErrorLogEntry = {
		id: `err-${sequence}`,
		error,
		count: 1,
		firstAt: error.timestamp,
		lastAt: error.timestamp
	};
	return { log: [entry, ...log].slice(0, ERROR_LOG_CAP), entry, isNew: true };
}
